export const inputSizes = {
  '64': '64',
  '72': '72',
}

export const inputPaddingsRemDefault = {
  [inputSizes[64]]: '1.875rem 1rem 0.375rem',
  [inputSizes[72]]: '2.125rem 1rem 0.625rem',
}

export const inputPaddingsRemWithIsClearable = {
  [inputSizes[64]]: '1.875rem 3.5rem 0.375rem 1rem',
  [inputSizes[72]]: '2.125rem 3.5rem 0.625rem 1rem',
}

export const inputPaddingsRemWithButton = (buttonWidth: number) => ({
  [inputSizes[64]]: `1.875rem calc(1.75rem + ${buttonWidth}px) 0.375rem 1rem`,
  [inputSizes[72]]: `2.125rem calc(1.75rem + ${buttonWidth}px) 0.625rem 1rem`,
})

export const inputPaddingsRemWithIsClearableAndButton = (buttonWidth: number) => ({
  [inputSizes[64]]: `1.875rem calc(3.75rem + ${buttonWidth}px) 0.375rem 1rem`,
  [inputSizes[72]]: `2.125rem calc(3.75rem + ${buttonWidth}px) 0.625rem 1rem`,
})

export const inputBorderRadiusesRem = {
  [inputSizes[64]]: '1rem',
  [inputSizes[72]]: '1.25rem',
}

export const inputPaddingsPxDefault = {
  [inputSizes[64]]: '30px 16px 6px',
  [inputSizes[72]]: '34px 16px 10px',
}

export const inputPaddingsPxWithIsClearable = {
  [inputSizes[64]]: '30px 56px 6px 16px',
  [inputSizes[72]]: '34px 56px 10px 16px',
}

export const inputPaddingsPxWithButton = (buttonWidth: number) => ({
  [inputSizes[64]]: `30px ${buttonWidth + 32}px 6px 16px`,
  [inputSizes[72]]: `34px ${buttonWidth + 32}px 10px 16px`,
})

export const inputPaddingsPxWithIsClearableAndButton = (buttonWidth: number) => ({
  [inputSizes[64]]: `30px ${buttonWidth + 64}px 6px 16px`,
  [inputSizes[72]]: `34px ${buttonWidth + 64}px 10px 16px`,
})

export const inputBorderRadiusesPx = {
  [inputSizes[64]]: '16px',
  [inputSizes[72]]: '20px',
}
